import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tipoRetiro'
})
export class TipoRetiroPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value == 0){
      return '1';
    }else if(value >= 1 && value <= 2){
      return '2';
    }else if(value >= 3){
      return '3';
    }else{
      return value;
    }
  }

}
